module.exports = {"360824001":"洋峰街道办","360824100":"金川镇","360824101":"三湖镇","360824102":"大洋洲镇","360824103":"七琴镇","360824104":"麦斜镇","360824105":"界埠镇","360824106":"溧江镇","360824201":"桃溪乡","360824202":"城上乡","360824203":"潭丘乡","360824204":"神政桥乡","360824205":"沂江乡","360824207":"荷浦乡","360824404":"新干工业园区","360824405":"地质大队","360824502":"黎山林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360824.json
// module id = 1209
// module chunks = 0